import { Type } from "class-transformer";
import { observable } from "mobx";
import "reflect-metadata";
import { EntityValidationRules } from "services/validationService";

export const ChargeTypeIdValidationRules: EntityValidationRules<ChargeOrderChargeItem> = {
  chargeTypeId: {
    required: true,
  },
};

export default class ChargeOrderChargeItem {
  @Type(() => Date)
  @observable
  validSince?: Date;

  @Type(() => Date)
  @observable
  _validUntil?: Date;

  @observable
  chargeTypeId?: string;

  @observable
  _hasImmediateValidity?: boolean;

  @Type(() => Date)
  @observable
  _validSinceDaysBefore?: Date;

  constructor(validSince?: Date, chargeTypeId?: string, hasImmediateValidity?: boolean) {
    this.validSince = validSince;
    this.chargeTypeId = chargeTypeId;
    this._hasImmediateValidity = hasImmediateValidity;
  }
}

export const OrderChargeItemValidationRules: EntityValidationRules<ChargeOrderChargeItem> = {
  ...ChargeTypeIdValidationRules,
};

export const OrderChargeItemBatchValidationRules: EntityValidationRules<ChargeOrderChargeItem> = {
  ...ChargeTypeIdValidationRules,
};
